import api from 'core/api';

export const search = (data) => api.post('/search/search', { ...data });
export const searchChannelMembers = (data) => api.post('/search/channel_members', { ...data });
export const autocomplete = (data) => api.get('/search/autocomplete', { params: { ...data } });
export const featured = (data) => api.get('/search/featured', { params: { ...data } });
